/* eslint-disable react/prop-types */ // TODO: add props
import { useState } from 'react';
import cx from 'classnames';
import style from './ActivationLinkCard.scss';

import CopyIconSVG from './CopyIconSVG';
import CopiedIconSVG from './CopiedIconSVG';

const ActivationLinkCard = ({ activationLink }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [message, setMessage] = useState('');

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(activationLink)
      .then(() => {
        setMessage('Copied!');
        setCopySuccess(true);
      })
      .catch(() => setMessage("Couldn't copy, sorry!"));
  };

  return (
    <div className={style.activationLinkCard}>
      <span
        className={cx(style.activationLink, {
          [style.highlight]: copySuccess,
        })}
      >
        {activationLink}
      </span>
      <span className={style.copyActivationLink}>
        {!copySuccess && (
          <a onClick={handleCopyLink}>
            <span className={style.copyLinkIcon}>
              <CopyIconSVG />
            </span>
            Copy link
          </a>
        )}
      </span>
      {message && (
        <div
          className={cx({
            [style.error]: !copySuccess,
            [style.copied]: copySuccess,
          })}
        >
          <CopiedIconSVG />
          <span>{message}</span>
        </div>
      )}
    </div>
  );
};

export default ActivationLinkCard;
